import { schema } from 'normalizr';

export default new schema.Entity(
  'companies',
  {},
  {
    idAttribute: 'cid',
  }
);
